import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {Slider} from 'rmwc';

import * as styles from '../../styles';
import Content from '../../content-manager/content';
import {request} from '../../containers/actions';
import { host_v2 } from '../../utilities/requests';

//Radium(Comment);
export default class Comment extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    };

    static defaultProps = {
        refresh: _.identity,
        header: () => null,
        style: {box: {}},
        rates: [],
    };

    state = {
        edit: false,
        body: this.props.data.body,
    };

    componentWillReceiveProps(nextProps) {
        if ((nextProps.data || {}).body !== (this.props.data || {}).body)
            this.setState({body: (nextProps.data || {}).body});
    }

    render() {
        const generatedStyles = (_.isFunction(this.props.style) ? this.props.style(this.props.data) : this.props.style) || {};
        generatedStyles.box = generatedStyles.box || {};
        return <div
            style={{
                ...styles.shadowBox,
                marginBottom: '1.5em',
                display: 'inline-block',
                width: '100%',
                ...generatedStyles.box,
                position: 'relative',
            }}>
            <div
                style={{
                    fontSize: '.85em',
                    backgroundColor: '#eaeaea',
                    marginBottom: '.75em',
                    padding: '.5em',
                    ...generatedStyles.header,
                }}>
                <div style={{float: 'left', color: '#9a9a9a'}}>
                    {this.props.data.extra.accepted === false || this.props.data.extra.accepted === true
                        ? <span
                            style={{
                                fontSize: '.9em',
                                marginLeft: '2em',
                                color: this.props.data.extra.accepted === true
                                    ? styles.successColor
                                    : this.props.data.extra.accepted === false
                                        ? styles.alertColor
                                        : undefined,
                            }}>
                            {this.props.data.extra.accepted
                                ? window.gettext('Accepted')
                                : window.gettext('Not Accepted')
                            }
                        </span>
                        : null
                    }
                    <span style={{fontSize: '.9em', marginLeft: '.4em'}}>
                        {this.props.data.timestamp.toJalali().persian('dddd - YYYY MMMM DD - hh:mm:ss')}
                    </span>
                    {(
                        this.context.user.hasPerm('book.comments') ||
                        this.context.user.hasPerm('examination.complaints') ||
                        this.context.user.hasPerm('examination.comments')
                    )
                        ? <span>
                            <i
                                key='trash'
                                style={{
                                    fontSize: '1.4em',
                                    cursor: 'pointer',
                                    ':hover': {color: '#5a5a5a'},
                                    marginRight: '.3em',
                                }}
                                className='fa-trash'
                                onClick={async () => {
                                    await this.context.store.dispatch(request({
                                        path: `/comment/${this.props.data.id}/`,
                                        method: 'DELETE',
                                    }));
                                    this.props.refresh();
                                }}>
                            </i>
                            <i
                                key='save'
                                style={{
                                    fontSize: '1.4em',
                                    cursor: 'pointer',
                                    ':hover': {color: '#5a5a5a'},
                                    marginRight: '.3em',
                                }}
                                className='fa-save'
                                onClick={async () => {
                                    await this.context.store.dispatch(request({
                                        path: `/comment/${this.props.data.id}/`,
                                        method: 'PATCH',
                                        body: {body: this.state.body},
                                    }));
                                    this.props.refresh();
                                }}>
                            </i>
                            <i
                                key='confirm'
                                style={{
                                    fontSize: '1.4em',
                                    cursor: 'pointer',
                                    ':hover': {color: '#5a5a5a'},
                                    marginRight: '.3em',
                                }}
                                className={`fa ${this.props.data.confirmed ? 'fa-check' : 'fa-times'}`}
                                onClick={async () => {
                                    await this.context.store.dispatch(request({
                                        path: `/comment/${this.props.data.id}/`,
                                        method: 'PATCH',
                                        body: {confirmed: !this.props.data.confirmed},
                                    }));
                                    this.props.refresh();
                                }}>
                            </i>
                            {_.map(
                                this.props.actions,
                                (action, index) => <i
                                    key={'action-' + index}
                                    style={{
                                        fontSize: '1.4em',
                                        cursor: 'pointer',
                                        ':hover': {color: '#5a5a5a'},
                                        marginRight: '.3em',
                                    }}
                                    className={`fa ${action.icon(this.props.data)}`}
                                    onClick={() => action.action(this.props.data, this.props)}>
                                </i>,
                            )}
                        </span>
                        : null
                    }
                </div>
                {this.props.data.user
                    ? <a target='_blank' href={host_v2 + `/Users?userId=${this.props.data.user.id}`}>{this.props.data.user.firstname} {this.props.data.user.lastname}</a>
                    : window.gettext('Guest User')
                }
                &nbsp;
                {_.isFunction(this.props.header) ? this.props.header(this.props.data) : this.props.header}
            </div>
            {this.props.rates.length > 0
                ? <div
                    style={{
                        width: this.props.ratesWidth,
                        float: 'right',
                        paddingLeft: '.5em',
                    }}>
                    {_.map(
                        this.props.rates,
                        (text, index) => _.find(this.props.data.rates, item => item.target[2] === text)
                            ? <span key={index}>
                                <div style={{color: '#8a8a8a', marginTop: '-.5em', marginBottom: '-1em'}}>
                                    {text}
                                </div>
                                <Slider
                                    min={0}
                                    max={5}
                                    discrete
                                    displayMarkers
                                    color={styles.successColor}
                                    disabled
                                    value={_.find(this.props.data.rates, item => item.target[2] === text).value}
                                />
                            </span>
                            : null,
                    )}
                </div>
                : null
            }
            <div
                style={{
                    width: this.props.rates.length > 0 ? `calc(100% - 1.5em - ${this.props.ratesWidth})` : '100%',
                    float: 'left',
                    boxSizing: 'border-box',
                    color: this.props.data.extra.accepted === true
                        ? styles.successColor
                        : this.props.data.extra.accepted === false
                            ? styles.alertColor
                            : undefined,
                    ...generatedStyles.body,
                }}>
                {(
                    this.context.user.hasPerm('book.comments') ||
                    this.context.user.hasPerm('examination.complaints') ||
                    this.context.user.hasPerm('examination.comments')
                )
                    ? <Content
                        key={'comment-' + this.props.data.id}
                        id={'comment-' + this.props.data.id}
                        inline
                        content={this.state.body || ''}
                        onChange={content => this.setState({body: content})}
                    />
                    : <div
                        dangerouslySetInnerHTML={{__html: this.state.body}}
                        style={styles.content}
                    />
                }
            </div>
        </div>;
    }
}
